import { TaskState } from "./TaskContext.types";

export const defaultTaskState: TaskState = {
  tasks: [],
};
